<template>
  <ul class="zd-step">
    <li v-for="(item, index) in list" :key="index">
      <div class="step-box">
        <div class=" ml-16" :class="[currentStep == index ? 'successItem' : (currentStep > index?'preItem':'feltItem'), isDialog ? 'step-nomal-dialog' : 'step-nomal']">
          <div v-if="currentStep > index" :class="isDialog ? 'check-dialog' : 'check'" /><span v-else>{{ index + 1 }}</span>
        </div>
        <div class="ml-8" :class="[currentStep == index ? 'successTitile' : (currentStep > index?'preTitle':'feltTitile'), isDialog ? 'small-size' : 'medium-size'] ">{{
          item.title
        }}</div>
        <div v-if="index !== list.length - 1" class="line " :class="currentStep > index ? 'successLine' : 'feltLine'" />

      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'MyStep',
  props: {
    list: {
      // { status: 'primary info warning error' },
      type: Array,
      default: () => []
    },
    isDialog: {
      type: Boolean,
      default: () => false
    },
    currentStep: {
      // 当前步骤
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  mounted() { },
  methods: {}
}
</script>
<style lang="scss" scoped>
.zd-step {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px 0;
  .step-box {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .step-nomal {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      line-height: 32px;

      & > span {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .step-nomal-dialog {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      line-height: 26px;

      & > span {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .successItem {
      // background: #fff;
      // color: $primary-color;
      border: 1px solid $primary-color;
      background: $primary-color;
      color: #fff;
    }
    .preItem {
      // background: #fff;
      color: #fff;
      border: 1px solid $primary-color;
    }
    .check {
      position: relative;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .check:before {
      position: absolute;
      content: "";
      width: 9px;
      height: 16px;
      transform: rotate(45deg);
      border-right: 2px solid $primary-color;
      border-bottom: 2px solid $primary-color;
      top: 5px;
      left: 11px;
    }
    .check-dialog {
      position: relative;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .check-dialog:before {
      position: absolute;
      content: "";
      width: 4px;
      height: 9px;
      transform: rotate(45deg);
      border-right: 2px solid $primary-color;
      border-bottom: 2px solid $primary-color;
      top: 6px;
    }

    .feltItem {
      background: #fff;
      color: #999999;
      border: 1px solid #999999;
    }
    .preTitle {
      color: $primary-color;
      font-weight: 500;
    }
    .successTitile {
      color: $primary-color;
      font-weight: 500;
    }
    .feltTitile {
      color: #999999;
    }
    .line {
      min-width: 130px;
      height: 1px;
      margin-left: 16px;
    }
    .successLine {
      // background: $primary-color;
      background: $primary-color;
    }
    .small-size {
      font-size: 14px;
    }
    .feltLine {
      background: #999999;
    }
  }
}
</style>
